import { RequestTypes } from '../requestTypes'
import { authKeys } from '..'
import { IdentityProvider } from '@core/entities/auth'
import { UseQueryOptions, useQuery } from '@tanstack/react-query'
import { RequestErrorType } from '@core/utils/api-axios-instance'

export const useGetIdentityProvider = (
  payload: RequestTypes['getIdentityProvider'],
  options?: UseQueryOptions<
    IdentityProvider,
    RequestErrorType,
    IdentityProvider
  >,
) => {
  return useQuery({
    ...authKeys.getIdentityProvider(payload),
    networkMode: 'always',
    ...options,
  })
}
